import type { GetColorDefinition } from 'atoms/colors/colors';

// eslint-disable-next-line import/prefer-default-export
export const hexToRGB = (hexString: string) => {
  const hex = hexString.length === 7 ? hexString.substring(1).match(/.{1,2}/g) : hexString.match(/.{1,2}/g);
  const rgbArray = hex && [parseInt(hex[0], 16), parseInt(hex[1], 16), parseInt(hex[2], 16)];
  if (!rgbArray) {
    throw new Error('You must provide a valid hex string');
  }

  return rgbArray as [number, number, number];
};

export const toCamelCase = (string: string) =>
  string.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_m, chr) => chr.toUpperCase());

export const stringToKebabCase = (string: string) => string.replaceAll(' ', '-').toLowerCase().trim();

export const deKebabString = (id: string) => id.replace(/(^|\/|-)(\S)/g, s => s.toUpperCase());

export const getBackgroundColor = (backgroundColor: string) =>
  backgroundColor === 'White' ? 'common-white' : (stringToKebabCase(backgroundColor) as GetColorDefinition);

export const colorTheme = (color: string) => {
  const colorMap = {
    black: 'common-black',
    white: 'common-white',
    navy900: 'navy-900',
    navy800: 'navy-900',
    gray900: 'gray-900',
    gray700: 'gray-700',
    gray100: 'gray-50',
    blue600: 'blue-600',
  } as const;

  type Colors = keyof typeof colorMap;

  const getColors = (cmsColor: string) => toCamelCase(cmsColor) as Colors;

  return colorMap[getColors(color || 'Primary 300')];
};

export const getYoutubeId = (url: string) => {
  const urlMatches = url?.match(/(?:[?&]v=|\/embed\/|\/1\/|\/v\/|https:\/\/(?:www\.)?youtu\.be\/)([^&\n?#]+)/);

  return urlMatches?.[1];
};

export const formatDate = (dateStr: string, short?: boolean) => {
  const tmp = new Date(dateStr);
  let date = '';
  if (tmp.getDate() < 10) {
    date = '0' + tmp.getDate();
  } else {
    date = tmp.getDate().toString();
  }

  return tmp.toLocaleString('en-us', { month: short ? 'short' : 'long' }) + ' ' + date + ', ' + tmp.getFullYear();
};

export const validateEmail = (email: string) => {
  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (email.match(validRegex)) {
    return true;
  }

  return false;
};

export const numberWithCommas = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const pollForDefinition = (scope: object, varname: string, callback: any) => {
  if (typeof scope[varname] !== 'undefined') {
    callback();

    return;
  }
  const interval = setInterval(() => {
    if (typeof scope[varname] !== 'undefined') {
      clearInterval(interval);
      callback();
    }
  }, 150);
};
